import React from 'react';
import styles from './completeModal.module.scss';
import Modal from '@src/components/modal/Modal';
import Button from '@src/components/button/Button';
import Spinner from '@src/components/spinner/Spinner';
import { isHomeEDApp } from '@src/constants';
import { useCourseContent } from '@src/hooks';

type Props = {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onContinue: () => void;
  onComplete: () => void;
  onJustView: () => void;
  completed?: boolean;
};

function CompleteModal(props: Props) {
  const { open, loading, onClose, onContinue, onComplete, onJustView, completed } = props;
  const { section, startedAlternateLesson } = useCourseContent();
  return (
    <Modal global={false} open={open} onClose={onContinue} className={styles.wrapper} closeButton={false} >
      <div className={styles.container}>
        <div className={styles.content}>
          {completed ? (
            startedAlternateLesson ? 
            <div className={styles.title}>Do you want to<span className='bold'> mark {section?.name} <br/>as complete?</span></div> :
            <div className={styles.title}><span className='bold'>Congratulations!</span> You completed<br/> this Lesson. Do you want to mark <br />the Lesson as <span className='bold'>Completed?</span></div>
          ) : (
            startedAlternateLesson ? 
            <div className={styles.title}>Do you want to<span className='bold'> mark {section?.name} <br/>as complete?</span></div> :
            <div className={styles.title}>Do you want to<span className='bold'> mark lesson <br/>complete?</span></div>
          )}
          <div className={styles.btnWrapper}>
            <Button disabled={loading} size={'small'} onClick={isHomeEDApp ? onClose : onJustView} leftIcon={loading ? <Spinner width={35} height={35} /> : undefined} outline={true} className={styles.start} label={'Not Yet'}/>
            <Button disabled={loading} size={'small'} onClick={onComplete} leftIcon={loading ? <Spinner width={35} height={35} /> : undefined} className={styles.resume} label={'Yes'}/>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default CompleteModal;
